export const userRolesMap = {
  editor: {
    pretty_label: 'Editor',
  },
  viewer: {
    pretty_label: 'Viewer',
  },
}

// NOTE: Prefer using the store version of this helper
export const isViewer = (user) => hasRole(user, 'viewer')
export const isEditor = (user) => hasRole(user, 'editor')

export const presentUserRole = (user) => {
  if (isViewer(user)) return userRolesMap['viewer'].pretty_label

  return userRolesMap['editor'].pretty_label
}

export const rawUserRole = (user) => {
  if (isViewer(user)) return 'viewer'

  return 'editor'
}

const hasRole = (user, role: string) => {
  return user?.account_roles?.indexOf(role) > -1
}
